import auth from '../../auth/index'
import * as types from '../mutation-types'

const state = {
    user: {},
    is_admin: null,
    permissions: {},
    isLogged: null
};

const getters = {
    shortName: state => {
        return state.user.login; //(state.user && state.user.login) ? state.user.login.substr(0, 2) : ''
    },

    isAdmin: state => {
        return state.user && (state.user.profile_id === 1 || state.user.profile_id === 3);
    },

    isLogged: state => {
        return state.user && state.user.id;
    }
};

const actions = {
    isLogged({ dispatch, state}){
        if (state.isLogged === null) {
            return dispatch('checkUser');
        } else {
            return Promise.resolve(state.isLogged)
        }
    },
    checkUser ({ commit, state}) {
        return auth.fetchUser().then((userData) => {
            commit(types.SET_USER_DATA, userData)
            return state.isLogged
        })
    }
};

const mutations = {
    [types.SET_USER_DATA] (state, userData) {
        state.user = userData ? userData : {}
        // if (userData) {
        //     state.permissions = state.user.group.permissions;
        //     state.is_admin = state.user.group.is_admin;
        // }
        state.isLogged = !!userData
    },

    [types.REMOVE_USER_DATA] (state) {
        state.user = {}
        state.isLogged = false
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/auth.js